const DexpTrackingKeys = {
    PLEASE_ENTER_SEARCH_NUMBER: "pleaseEnterSearchNumber",
    RETRIEVE_SUCCESS_MESSAGE: "retrieveSuccessMessage",
    FAILED_TO_RETRIEVE_ERROR_MESSAGE: "failedToRetrieveErrorMessage",
    FAILED_TO_TRACK_ERROR_MESSAGE: "failedToTrackErrorMessage",
    CONTAINER_NO: "containerNo",
    CCN: "ccn",
    NO_RECORD_FOUND: "noRecordFound",
    VIEWING: "viewing",
    CONTAINER_HISTORY: "containerHistory",
    FOR_CUSTOMS_STATUS_PLEASE_SEARCH_BY: "forCustomsStatusPleaseSearchBy",
    CNTR: "cntr",
    VESSEL: "vessel",
    DAYS_AT_PORT: "daysAtPort",
    TITLE: "title",
    LOGIN_BUTTON: "loginButton",
    REGISTER_BUTTON: "registerButton",
    COMPLIANCE_SUMMARY_TITLE: "complianceSummaryTitle",
    MASTER_LEVEL_TITLE: "masterLevelTitle",
    PRIMARY_ACI_MANIFESTS: "primaryACIManifests",
    PRIMARY_ACI_OCEAN_MANIFEST: "primaryACIOceanManifest",
    NOTE: "note",
    HOUSE_LEVEL_TITLE: "houseLevelTitle",
    EHBLS: "ehbls",
    RELEASED: "released",
    ACCEPTED: "accepted",
    ACCEPTED_CBSA: "acceptedCBSA",
    SUBMITTED: "submitted",
    HELD: "held",
    REJECTED: "rejected",
    DATA_NOT_AVAILABLE: "dataNotAvailable",
    TIMELINE_TITLE: "timelineTitle",
    CUSTOMS_HOLD: "customsHold",
    STORAGE_CHARGE_LAST_FREE_DAY: "storageChargeLastFreeDay",
    RAIL_BAD_ORDER_AARBO_DESCRIPTION: "railBadOrderAarboDescription",
    RAIL_BAD_ORDER_BO_CODE_DESCRIPTION: "railBadOrderBoCodeDescription",
    RAIL_DEPARTURE_ETA_SUPERSEDES_NOTE: "railDepartureETASupersedesNote",
    RAIL_SUMMARY: "railSummary",
    GROSS_WEIGHT: "grossWeight",
    LOAD_EMPTY: "loadEmpty",
    LOAD_EMPTY_E: "loadEmptyE",
    LOAD_EMPTY_L: "loadEmptyL",
    LOAD_EMPTY_C: "loadEmptyC",
    WAYBILL_STATUS: "waybillStatus"
}

export default DexpTrackingKeys